import React from "react";
import Button from "../button/Button";
import { IconName } from "../icon/src/helper";
import { useFormContext } from "react-hook-form";
import { StyleSize } from "../../common/models";

interface Props {
  label: string;
  icon?: IconName;
  className?: string;
  size?: StyleSize;
  isDisabled?: boolean;
}

const SubmitButton: React.FC<Props> = (props): React.ReactElement => {
  const {
    formState: { isSubmitting },
  } = useFormContext();

  return (
    <Button
      label={props.label}
      mode="primary"
      icon={props.icon}
      type="submit"
      loading={isSubmitting}
      className={props.className}
      size={props.size}
      disabled={props.isDisabled ?? isSubmitting}
    />
  );
};

export default SubmitButton;
